import React from "react";
import AppConfirmationPrompt from "../Components/AppConfirmationPrompt";

interface Props {
  onHide: () => void;
  show: boolean;
  setConfirmDelete: (isConfirm: boolean) => void;
}

const DeletePostModal: React.FC<Props> = ({ onHide, show, setConfirmDelete }) => {
  return (
    <AppConfirmationPrompt
      show={show}
      title="Delete Intro Post?"
      body="This action cannot be undone."
      confirmText="Delete"
      cancelText="Cancel"
      onClose={onHide}
      onConfirm={() => setConfirmDelete(true)}
      onCancel={() => setConfirmDelete(false)}
    />
  );
};

export default DeletePostModal;
